<template>
  <div class="word-center-page">
    <header class="word-center-header">
      <button class="word-center-back" type="button" :aria-label="$t('Back')" @click="back">
        <img src="../../static/images/livequiz/back.png" alt="" />
      </button>
    </header>

    <main class="word-center-content">
      <img class="word-center-title" src="../../static/images/word_quiz/word_quiz_title.png" :alt="$t('WordQuiz')" />

      <section class="word-center-grid" :aria-label="$t('WordQuiz')">
        <button class="word-center-card" type="button" @click="goBattleRoom('waitRobot')">
          <img class="word-center-card-art" src="../../static/images/word_quiz/ai_training.png" alt="" />
          <span class="word-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('WordQuizAITraining') }}</strong>
            <em>{{ $t('WordQuizAITrainingC') }}</em>
          </span>
        </button>

        <button class="word-center-card" type="button" @click="goBattleRoom('paiwei')">
          <img class="word-center-card-art" src="../../static/images/word_quiz/ranked_mode.png" alt="" />
          <span class="word-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('WordQuizRankedMode') }}</strong>
            <em>{{ $t('WordQuizRankedModeC') }}</em>
          </span>
        </button>

        <button class="word-center-card" type="button" @click="goBattleRoom('pk')">
          <img class="word-center-card-art" src="../../static/images/word_quiz/team_mode.png" alt="" />
          <span class="word-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('WordQuizTeamMode') }}</strong>
            <em>{{ $t('WordQuizTeamModeC') }}</em>
          </span>
        </button>

        <button class="word-center-card" type="button" @click="goBattleRoom('single')">
          <img class="word-center-card-art" src="../../static/images/word_quiz/endless_mode.png" alt="" />
          <span class="word-center-card-copy">
            <img src="../../static/images/quiz_center/txt_bg.png" alt="" />
            <strong>{{ $t('WordQuizEndlessMode') }}</strong>
            <em>{{ $t('WordQuizEndlessModeC') }}</em>
          </span>
        </button>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  methods: {
    back () {
      this.$router.go(-1)
    },
    goBattleRoom (route) {
      this.$router.push({path: '/' + route})
    }
  }
}
</script>

<style scoped>
.word-center-page {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 46px 28px 96px;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') no-repeat center top;
  background-size: 100% auto;
  color: #fff;
  font-family: Arial, Atom-sans, sans-serif;
}

.word-center-page::before {
  position: fixed;
  z-index: 0;
  inset: 0;
  content: '';
  background: linear-gradient(180deg, rgba(12, 0, 44, .04), rgba(8, 0, 34, .48) 58%, rgba(7, 0, 29, .9));
  pointer-events: none;
}

.word-center-header {
  position: absolute;
  z-index: 2;
  top: 46px;
  right: 0;
  left: 0;
  width: calc(100% - 56px);
  max-width: 650px;
  margin: 0 auto;
}

.word-center-back,
.word-center-card {
  padding: 0;
  border: 0;
  color: inherit;
  background: transparent;
  font: inherit;
  cursor: pointer;
}

.word-center-back {
  display: flex;
  width: 72px;
  height: 72px;
  align-items: center;
  justify-content: center;
}

.word-center-back img { display: block; width: 100%; height: 100%; object-fit: contain; }

.word-center-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
}

.word-center-title {
  display: block;
  width: min(100%, 650px);
  margin: 0 auto 26px;
}

.word-center-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0 -14px;
  gap: 18px 14px;
}

.word-center-card {
  position: relative;
  display: block;
  min-width: 0;
  overflow: hidden;
  border-radius: 28px;
}

.word-center-card-art { display: block; width: 100%; }

.word-center-card-copy {
  position: absolute;
  right: 3%;
  bottom: 3%;
  left: 3%;
  display: block;
  height: 46%;
  overflow: hidden;
  border-radius: 18px;
}

.word-center-card-copy > img { display: block; width: 100%; height: 100%; }

.word-center-card-copy strong,
.word-center-card-copy em {
  position: absolute;
  right: 7%;
  left: 7%;
  text-align: center;
}

.word-center-card-copy strong {
  top: 13%;
  color: #fff;
  font-size: clamp(14px, 4.2vw, 30px);
  font-weight: 900;
  line-height: 1;
  letter-spacing: -.035em;
  text-shadow: 0 3px 3px rgba(33, 0, 25, .86);
  text-transform: uppercase;
  white-space: nowrap;
}

.word-center-card-copy em {
  top: 45%;
  color: #ffe968;
  font-size: clamp(11px, 3.2vw, 25px);
  font-style: normal;
  font-weight: 500;
  line-height: 1.13;
  white-space: pre-line;
}

@media (min-width: 760px) {
  .word-center-title { margin-bottom: 40px; }
}
</style>



// WEBPACK FOOTER //
// src/page/wordCenter.vue